import { createUseStyles } from "react-jss";
import { colors } from "../../../constants/colors";
import { breakpoints } from "../../../constants/breakpoints";

const styles = createUseStyles(theme => ({
  modal: {
    width: "400px",
    "& .modal-header": {
      padding: "24px 24px 20px",
      "& div": {
        height: "48px",
        width: "48px",
        padding: "12px",
        border: theme.icon.border,
        borderRadius: theme.icon.borderRadius,
        boxShadow: theme.icon.boxShadow,
        backgroundColor: theme.icon.backgroundColor,
        "& svg": {
          display: "flex"
        }
      },
      "& button": {
        fontSize: "14px",
        position: "absolute",
        top: "32px",
        right: "32px"
      }
    },
    "& .modal-title": {
      padding: "0 24px"
    },
    "& .modal-body": {
      padding: "8px 24px"
    },
    "& .modal-footer": {
      padding: "24px 24px"
    },
    "& .modal-footer>*": {
      margin: "0px"
    },
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      width: "auto"
    }
  },
  cancelBtn: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
  },
  deleteDefaultDescription: {
    fontSize: "14px",
    color: colors.mediumGrey,
    margin: "0px"
  }
}));

export default styles;
